import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { mapActions } from "vuex";
import RejectModal from "@/views/community/components/RejectModal.vue";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "community-audit",
  components: {
    RejectModal: RejectModal
  },
  data: function data() {
    return {
      searchForm: {
        page: 1,
        limit: 20,
        audit_status: "0"
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      ids: [],
      // 批量审核id

      remarkDialogVisible: false,
      currentRemarkObj: {},
      categoryList: [],
      //类别
      auditForm: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data, filterKeys;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.databasePage({
              user: true
            });
          case 1:
            _this.pageDB = _context.v;
            _context.n = 2;
            return _this.pageDB.value();
          case 2:
            data = _context.v;
            if (data.searchForm) {
              filterKeys = ["categories"];
              filterKeys.forEach(function (key) {
                if (data.searchForm[key] !== undefined) {
                  _this.searchForm[key] = data.searchForm[key];
                }
              });
            }
            _this.getCategoryList();
            _this.getData();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    searchForm: {
      handler: function handler() {
        var _this2 = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var filterState, filterKeys;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (_this2.pageDB) {
                  filterState = {};
                  filterKeys = ["categories"];
                  filterKeys.forEach(function (key) {
                    filterState[key] = _this2.searchForm[key];
                  });
                  _this2.pageDB.set("searchForm", filterState).write();
                }
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }))();
      },
      deep: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["database", "get", "databasePage"])), {}, {
    getCategoryList: function getCategoryList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getCommunityCategoryList({
                page: 1,
                limit: 100
              });
            case 1:
              res = _context3.v;
              _this3.categoryList = res.data.list;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row;
      this.remarkDialogVisible = true;
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _params$categories;
        var params, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.page = 1;
              }
              _this4.tableLoading = true;
              _this4.searchForm.audit_status = "0"; // 待审核
              params = JSON.parse(JSON.stringify(_this4.searchForm));
              params.categories = (_params$categories = params.categories) === null || _params$categories === void 0 ? void 0 : _params$categories.join(",");
              _context4.n = 1;
              return _this4.$api.getCommunityList(params);
            case 1:
              res = _context4.v;
              res.data.list.forEach(function (item) {
                item.category_names = _toConsumableArray(new Set([].concat(_toConsumableArray((item === null || item === void 0 ? void 0 : item.text_category_names) || []), _toConsumableArray((item === null || item === void 0 ? void 0 : item.admin_category_names) || []), _toConsumableArray((item === null || item === void 0 ? void 0 : item.media_category_names) || []))));
              });
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.tableLoading = false;
              _this4.getUserListByIds(_this4.tableData, "user_id");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    setRejectRow: function setRejectRow(row) {
      console.log(row);
      this.auditForm = row;
    },
    reject: function reject(type) {
      this.audit('', 2, type);
    },
    // 审核
    audit: function audit(row, status, type) {
      var _this5 = this;
      row && this.setRejectRow(row);
      if (status === 1) {
        this.$confirm("是否通过?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                _this5.setAuditStatus(status, 0);
              case 1:
                return _context5.a(2);
            }
          }, _callee5);
        })));
      } else {
        this.setAuditStatus(status, type);
      }
    },
    setAuditStatus: function setAuditStatus(status, type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.auditCommunity({
                id: _this6.auditForm.id,
                audit_status: status,
                reject_type: type
              });
            case 1:
              _this6.$message.success(status == 1 ? "已通过" : "已拒绝");
              _this6.getData();
              // 操作上报
              _this6.$operationLog.push({
                code: status == 1 ? "pass" : "reject",
                userId: _this6.auditForm.user_id,
                operationType: "community",
                detailBatchNo: _this6.auditForm.id
              });
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/community/update",
        query: {
          id: row.id,
          userId: row.user.id,
          from: "community_audit_edit"
        }
      });
    }
  })
};